const detail = {
  "id": 1,
  "name": "nome sessione",
  "description": "descrzione session",
  "stato": "CREATED",
  "timestamp": 1635157600
}

const faseSeduta = [
  {
    id:1,
    name:'Apertura'
  },
  {
    id:2,
    name:'Annunci'
  },
  {
    id:3,
    name:'Sospensioni'
  },
  {
    id:5,
    name:'Fine seduta'
  },
  {
    id:4,
    name:'Altro'
  }
]
const events = [
  {
    id: 1,
    name: "Oratore",
    icon: ""
  },
  {
    id: 2,
    name: "Fase seduta",
    icon: ""
  },
  {
    id: 3,
    name: "Ordine del giorno",
    icon: ""
  }
]

export const SESSION = {
  detail,
  events,
  faseSeduta
}
